// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.col-sm-5.roster-option {
    border-radius: 8px;
    margin-left: 12px;
    margin-bottom: 12px;
    border: 2px solid black;
    position: relative;
    padding: 16px;
    cursor: pointer;
}

.col-sm-5.roster-option .overcolor {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    background-color: rgba(200,200,200,0.2);
    position: absolute;
    top: 0;
    left: 0;
    box-shadow: 0 0 10px 2px rgba(100,100,100,0.3) inset;
}

.col-sm-5.roster-option .overcolor:hover {
    background-color: rgba(200,200,200,0.4);
    box-shadow: 0 0 10px 4px rgba(100,100,100,0.4) inset;
}

.roster-table {
    width: 100%;
    text-align: center;
    display: table;
}

.roster-table td, .roster-table th {
    display: table-cell;
}

.roster-table th {
    font-size: 1.25rem;
}

.roster-table .active-cell {
    font-size: 0.75rem;
}

.roster-table img {
    margin-left: auto;
    margin-right: auto;
}

.type-img {
    padding: 2px;
}

.dex-sprite {
    display: block;
}

.roster-division-column {
    text-align: center;
    vertical-align: top;
}

.roster-img {
    height: 250px;
    /* width: 180px; */
    display: block;
    margin: auto;
}

.roster-img-title {
    text-decoration: none;
    text-align: center;
    color: black;
}

.australia-view {
    transform: rotate(180deg);
    /* Safari */
    -webkit-transform: rotate(180deg);

    /* Firefox */
    -moz-transform: rotate(180deg);

    /* IE */
    -ms-transform: rotate(180deg);

    /* Opera */
    -o-transform: rotate(180deg);
}

.button-bar {
    width: 40%;
    margin: auto;
    padding-bottom: 15px;
}

.triggerButton {
    display: block;
    margin: auto;
}`, "",{"version":3,"sources":["webpack://./src/component_css/Roster.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uCAAuC;IACvC,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,oDAAoD;AACxD;;AAEA;IACI,uCAAuC;IACvC,oDAAoD;AACxD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,iCAAiC;;IAEjC,YAAY;IACZ,8BAA8B;;IAE9B,OAAO;IACP,6BAA6B;;IAE7B,UAAU;IACV,4BAA4B;AAChC;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB","sourcesContent":[".col-sm-5.roster-option {\n    border-radius: 8px;\n    margin-left: 12px;\n    margin-bottom: 12px;\n    border: 2px solid black;\n    position: relative;\n    padding: 16px;\n    cursor: pointer;\n}\n\n.col-sm-5.roster-option .overcolor {\n    width: 100%;\n    height: 100%;\n    border-radius: 8px;\n    background-color: rgba(200,200,200,0.2);\n    position: absolute;\n    top: 0;\n    left: 0;\n    box-shadow: 0 0 10px 2px rgba(100,100,100,0.3) inset;\n}\n\n.col-sm-5.roster-option .overcolor:hover {\n    background-color: rgba(200,200,200,0.4);\n    box-shadow: 0 0 10px 4px rgba(100,100,100,0.4) inset;\n}\n\n.roster-table {\n    width: 100%;\n    text-align: center;\n    display: table;\n}\n\n.roster-table td, .roster-table th {\n    display: table-cell;\n}\n\n.roster-table th {\n    font-size: 1.25rem;\n}\n\n.roster-table .active-cell {\n    font-size: 0.75rem;\n}\n\n.roster-table img {\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.type-img {\n    padding: 2px;\n}\n\n.dex-sprite {\n    display: block;\n}\n\n.roster-division-column {\n    text-align: center;\n    vertical-align: top;\n}\n\n.roster-img {\n    height: 250px;\n    /* width: 180px; */\n    display: block;\n    margin: auto;\n}\n\n.roster-img-title {\n    text-decoration: none;\n    text-align: center;\n    color: black;\n}\n\n.australia-view {\n    transform: rotate(180deg);\n    /* Safari */\n    -webkit-transform: rotate(180deg);\n\n    /* Firefox */\n    -moz-transform: rotate(180deg);\n\n    /* IE */\n    -ms-transform: rotate(180deg);\n\n    /* Opera */\n    -o-transform: rotate(180deg);\n}\n\n.button-bar {\n    width: 40%;\n    margin: auto;\n    padding-bottom: 15px;\n}\n\n.triggerButton {\n    display: block;\n    margin: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
